import { useCallback, useEffect, useRef, useState } from 'react';
import { request } from '../../api/client';
import { beginFolderClick, folderHelperStatus, nativeFolderName, openHelperFolder, readFolderMode, supportsNativeFolders } from '../files/folderMode';
import { boardAvatarApi } from './boardAvatarApi';
import type { ProjectBoardTarget } from './ProjectDetailsModal';

export function useProjectFolderOpen(userId: number, browser: (target: ProjectBoardTarget) => void) {
  const pending = useRef<AbortController | null>(null), [notice, setNotice] = useState('');
  useEffect(() => () => pending.current?.abort(), [userId]);
  const open = useCallback(async (target: ProjectBoardTarget) => {
    pending.current?.abort();
    const controller = new AbortController(); pending.current = controller; setNotice('');
    const mode = readFolderMode(userId);
    if (mode === 'browser' || !supportsNativeFolders()) { browser(target); return; }
    const explicit = mode === 'windows' || mode === 'finder';
    try {
      let nonce = beginFolderClick();
      const helper = nonce ? 'ready' : await folderHelperStatus();
      if (controller.signal.aborted) return;
      if (helper === 'ready') {
        nonce ??= beginFolderClick();
        if (!nonce) throw new Error('helper-not-ready');
        const location = await boardAvatarApi.folder(target.id, controller.signal);
        controller.signal.throwIfAborted();
        const { ticket } = await request<{ ticket: string }>('/api/explorer/native-ticket', { method: 'POST', body: location, signal: controller.signal });
        if (await openHelperFolder(ticket, controller.signal, nonce)) return;
      }
      if (!controller.signal.aborted) { browser(target); if (explicit) setNotice(`Не удалось открыть ${nativeFolderName()}. Открыт браузерный проводник.`); }
    } catch {
      if (!controller.signal.aborted) { browser(target); if (explicit) setNotice('Открыт браузерный проводник.'); }
    }
  }, [browser, userId]);
  return { open, notice, dismiss: () => setNotice('') };
}
